<template lang="pug">
  div(class='listingBrowserDiv')
    div(v-if='!listings && !hideSpinner' class='loading-div')
      p Loading...
      div(class='loading-spinner') U
    div(v-for='listing in listings' :key='listing.ID' class='listingBrowserUnit' @click='showListing(listing)')
      h5 {{listing.StreetNumber}} {{listing.StreetName.replace(/\.$/, "")}}, {{(listing.City == "Boston" && listing.Neighborhood) ? listing.Neighborhood : listing.City}}
      //img(v-if="listing.Photos" v-bind:src="listing.Photos[0]")
      img(
        v-bind:src="listing.Photos ? listing.Photos[0] : require('../assets/uprightlogo.png')"
        v-bind:class="{logo: !listing.Photos}"
      )
      ul(class="unitDetailsList")
        li(v-if="listing.Fee == '1'" class="unitFee") No Fee
        li {{getBedBathString(listing.Beds, listing.Baths)}}
        li {{listing.BuildingType}}
        li(class="unitAvailable") {{ getAvailableString(listing) }}
        li(class="unitRent") {{"$" + listing.Price}}
        li(v-if="listing.RentIncludes" class="unitIncludes") Includes {{listing.RentIncludes.RentInclude.toString()}}
        li(class='photosCount' v-if="listing.Photos && listing.Photos.length > 1") {{listing.Photos.length}}
          i(class='el-icon-picture')
            //li(v-if="listing.IncludeGas=='1'" alt='Includes Gas')
              img(src="../assets/icongas.png")
            //li(v-if="listing.IncludeElectricity=='1'" alt="Includes Electricity")
              img(src="../assets/iconlightbulb.png")
            //li(v-if="listing.IncludeHeat=='1'" alt="Includes Heat")
              img(src="../assets/iconfire.png")
            //li(v-if="listing.IncludeHotWater=='1'" alt="Includes Hot Water")
              img(src="../assets/iconhotwater.png")
              
</template>

<script>
export default {
  props: {
    listings: Array,
    hideSpinner: Boolean,
  },
  methods: {
    showListing(listing){
      this.$emit('apt_unit_activated', {listing:listing, listings:this.listings});
    },
    getBedBathString(beds, baths){
      let returnString = "";
      let numBeds = parseInt(beds);
      if ( beds > numBeds){
        returnString = numBeds + "|" + (numBeds + 1) + " Bed Split"
      }
      else if (beds == 0 || beds.toLowerCase() === "studio"){
        returnString = "Studio";
      }
      else{
        returnString = numBeds + ((beds > 1) ? " Beds" : " Bed");
      }
      if (baths && baths > 0){
        if (returnString.length > 0) returnString += ", ";
        returnString += parseFloat(baths) + " Bath";
        if (baths > 1) returnString += "s";
      }
      return returnString;
    },
    getAvailableString(listing){
      return (listing.AvailableDate && new Date(listing.AvailableDate) > new Date())
        ? new Date(listing.AvailableDate).toLocaleDateString('us-EN', {month:'long', day:'numeric'})
        : "Available Now!";
    }
  }
}
</script>

<style scoped lang="scss" >
//@import '../_variables';

.listingBrowserDiv{
  //float: left;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  width: 100%;
  justify-content: center;
}
.listingBrowserUnit{
  //float: left;
  width: 300px;
  flex: 1 0 300px;
  height: 200px;
  margin: 5px;
  position: relative;
  text-align: left;
  border-top: 2px ridge $color-primary; 
  // box-shadow: 3px 3px 4px rgba(61, 60, 87, .5);
  // overflow: hidden; 
  /* border-radius: 15px; */
  transition: all .2s ease-in-out;
  cursor: pointer;
  max-width: 600px;
  min-width: 300px;
}

.listingBrowserUnit:hover{
  transform: scale(1.03);
  border-top: 2px ridge $color-accent; 
}

.listingBrowserUnit img{
  width: 50%;
  height: 82%;
  object-fit:cover;
  /* border-right: 3px solid rgba(69, 69, 116, 0.952); */
  margin-top: -5px;
  margin-left: 10px;
  margin-bottom: 10px;
  overflow:hidden;
  background-color: mix(black, $color-primary, 40);
}

.listingBrowserUnit img.logo{
  object-fit: scale-down;
}

.listingBrowserUnit h5{
  /* position: absolute; */
  color: $color-text-primary;
  /* background: rgba(69, 69, 116, 0.952); */
  width: 100%;
  /* border-top: 1px solid white; */
  font-size: 1.1em;
  bottom: 0;
  margin: 0;
  padding: 5px;
  /* font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif; */
  font-family: Helvetica, Arial, sans-serif;
  /* border-bottom: 1px solid white; */
  text-align: center;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
}

.unitDetailsList{
  position: absolute;
  top: 30px;
  left: 55%;
  list-style-type: none;
  margin: 0;
  padding: 0;
  font-size: .9em;
  display: flex;
  flex-direction: column;
  height: 80%;
  width: 45%;
}

.unitIncludes{
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  font-size: .7em;
}

li.unitRent{
  font-size: 1.5em;
  font-weight: bold;
  // color: mix(white, $color-accent, 40);
  color: rgb(138, 174, 221);
  // color: mix(white, $color-primary, 60);
  text-shadow: 1px 1px 2px black;
}

li.unitAvailable{
  font-style: italic;
  font-size: 1.1em;
  margin-top: auto;
}

li.unitFee{
  position: absolute;
  background-color: mix(black, $color-accent, 20%);
  padding: 3px;
  box-shadow: 2px 2px 3px black;
  color: white;
  left: -123%;
  top: 90%;
  /* right: 0; */
  
  transform: rotate(15deg);
}

.photosCount{
  position: absolute;
  left: -110%;
  top: 87%;
  font-size: 1.2em;
  color: white;
  text-shadow: 1px 1px 3px black;
  width: 100%;
  text-align: right;
}


.loading-div{
  text-align: center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'Rubik', Helvetica, Arial, sans-serif;
  font-size: 1.1em;
  color: rgb(173, 175, 193);
  justify-content: center;
}
.loading-spinner{
  padding: 0;
  font-size: 3em;
  border: 6px solid #323670; 
  border-top: 6px solid transparent; 
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1.3s linear infinite;
  margin: auto;
  animation-timing-function:ease-in-out;
}

</style>

